export default (payload) => ({
  type: 'UPDATE_CALLS_STATE',
  payload,
});
